import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';

export default class NotFound extends PureComponent {
  render() {
    return (
      <section className="align-items-center content d-flex justify-content-center vh-100">
        <div className="error-page mt-0">
          <h2 className="headline mb-0 text-warning">404</h2>
          <div className="error-content">
            <h3>
              <i className="fas fa-exclamation-triangle text-warning"></i> Oops!
              Page not found.{' '}
            </h3>
            <p className="mb-1">
              We could not find the page you were looking for.
            </p>
            <p>
              Meanwhile, you may return to <Link to="/a/sale">home</Link>.
            </p>
          </div>
        </div>
      </section>
    );
  }
}
